import React, { type HTMLAttributes } from 'react'

import { Link, type LinkProps } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

export const TabNav = React.forwardRef<HTMLElement, HTMLAttributes<HTMLElement>>(
  ({ children, className, ...props }, ref) => (
    <nav ref={ref} {...props} className={cn('flex gap-1', className)}>
      {children}
    </nav>
  )
)

export interface TabLinkProps extends LinkProps {
  readonly label: string
  readonly active: boolean
}

export const TabLink = React.forwardRef<HTMLAnchorElement, TabLinkProps>(({ label, active, ...props }, ref) => (
  <Link
    ref={ref}
    {...props}
    activeOptions={{ exact: true, includeSearch: false }}
    aria-current={active ? 'page' : undefined}
    className={cn(
      '-mb-px border-b-2 px-4 py-2.5 text-base',
      active
        ? 'border-blue-700 font-bold text-blue-700'
        : 'border-transparent font-medium text-gray-500 hover:text-gray-900'
    )}>
    {label}
  </Link>
))
